import { getWishlist } from "@repo/server-actions/wishlist";
import { Link } from "@/i18n/routing";
import { IconForwardArrow, IconNoWishlist } from "@repo/assets/images";
import { ProductSlider } from "@repo/components";
import { Button } from "@repo/ui";
import { getTranslations } from "next-intl/server";

const FavoriteProducts = async ({ isMedium, locale }) => {
  const tAccount = await getTranslations("Account");
  const tCommon = await getTranslations("Common");
  const wishlist = await getWishlist(locale);
  const isWishlistItemsExist = Boolean(wishlist?.content?.length);

  if (!isWishlistItemsExist && isMedium) return;

  return (
    <>
      <ProductSlider
        title={tCommon("Favourites")}
        items={wishlist?.content}
        wishlistItems={wishlist?.content}
        type="favorite"
        isMedium={isMedium}
      />
      {isWishlistItemsExist && !isMedium && (
        <Link href="/account/favourites" className="mt-4 block">
          <Button
            size="md"
            variant="secondary"
            className="flex w-full items-center justify-center"
          >
            {tAccount("See_All")}{" "}
            <IconForwardArrow className="rtl:rotate-180" />
          </Button>
        </Link>
      )}
      {!isWishlistItemsExist && !isMedium && (
        <div className="mx-auto flex flex-col items-center justify-center gap-3 py-20 text-center">
          <IconNoWishlist className="text-icon-color fill-icon-bg mx-auto" />
          <p className="font-heading rtl:font-arabic text-xl font-medium">
            {tAccount("No_Favourites_Added")}
          </p>
          <p className="text-supportiveGray4 pb-2 text-base font-medium">
            {tAccount("Save_The_Items_You_Love")}
          </p>
          <Link href={`/`}>
            <Button variant="primary" size="md" className="font-semibold">
              {tCommon("Start_Browsing")}
            </Button>
          </Link>
        </div>
      )}
    </>
  );
};

export default FavoriteProducts;
